import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountriesRequest } from '../store/addressSlice';
import {
  selectCountries,
  selectCountriesLoading,
  selectCountriesLoaded,
} from '../store/addressSelectors';

export function useCountries(section) {
  const dispatch = useDispatch();
  const countries = useSelector(selectCountries(section));
  const loading = useSelector(selectCountriesLoading(section));
  const loaded = useSelector(selectCountriesLoaded(section));

  useEffect(() => {
    if (!section) return;
    if (loaded || loading) return;
    dispatch(fetchCountriesRequest({ section }));
  }, [dispatch, section, loaded, loading]);

  return { countries, loading, loaded };
}
